import styled from 'styled-components'

export const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  height: 100%;
  min-height: 128px;
  padding: 20px 16px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.ds.colors.success1000};
  box-shadow: ${({ theme }) => theme.ds.shadows.normal};
`

export const TextWrapper = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 70%;

  @media (max-width: 480px) {
    max-width: 75%;
  }
`

export const Illustrations = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 192px;
  max-width: 45%;
  pointer-events: none;
`

export const TextureIllustration = styled.span`
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 1;
  display: flex;

  svg {
    height: auto;
    max-height: 148px;
  }
`

export const MegaphoneIllustration = styled.span`
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  z-index: 2;
  display: flex;
`
